import { Circle, Flex } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { Button } from "ui/Button/Button";
import { WarningThreeIcon } from "ui/Icons/Icons";
import { Modal } from "ui/Modal/Modal";
import { BodyM, HeaderS } from "ui/Typography/Typography";

export type UnverifiedQuantityModalProps = {
  onVerifyQuantity: () => void;
  isOpen: boolean;
};

export function UnverifiedQuantityModal({
  onVerifyQuantity,
  isOpen,
}: UnverifiedQuantityModalProps) {
  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={() => {}}
    >
      <Modal.Content marginX="s300">
        <Modal.Body textAlign="center" paddingY="0">
          <Flex align="center" marginY="s300" justify="center">
            <Circle bg="grey.100" size="120px">
              <WarningThreeIcon boxSize="80px" />
            </Circle>
          </Flex>
          <HeaderS>
            <FormattedMessage id="components.unverified-quantity-modal.header" />
          </HeaderS>
          <BodyM mt="s100">
            <FormattedMessage id="components.unverified-quantity-modal.body" />
          </BodyM>
        </Modal.Body>
        <Modal.Footer padding="s200">
          <Button mt="s100" onClick={onVerifyQuantity} isFullWidth variant="primary" size="lg">
            <FormattedMessage id="components.unverified-quantity-modal.button.label" />
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
